import request from '@/utils/request'
import gateway from '@/_gateway.config.js'

let { parent } = gateway

// 获取当前一周的课表
export function getTimetable (params) {
  return request({
    url: `${parent}/api/wx/class/schedule/list`,
    method: 'GET',
    params
  })
}

// 获取当前家长的所有学生
export function getStudentList (params) {
  return request({
    url: `${parent}/api/wx/student/list`,
    method: 'GET',
    params
  })
}

// 获取课程详情
export function getCourseInfo (params) {
  return request({
    url: `${parent}/api/wx/class/schedule/detail`,
    method: 'GET',
    params
  })
}

// 获取已报课程列表
export function getCourseStageList (params) {
  return request({
    url: `${parent}/api/wx/courseStage/detail/list`,
    method: 'GET',
    params
  })
}

// 1. 根据学生ID获取所在课期
export function getStudentCourseInfo (currStudentId) {
  return request({
    url: `${parent}/api/wx/courseStage/list?studentId=${currStudentId}`,
    method: 'get'
  })
}

// 2. 根据课期ID和学生ID获取所在课期详情
export function getStudentCourseDetail (params) {
  return request({
    url: `${parent}/api/wx/courseStage/detail?studentId=${params.studentId}&courseStageId=${params.courseStageId}`,
    method: 'get'
  })
}

// 修改学生信息
export function updateStudentInfo (data) {
  return request({
    url: `${parent}/api/math/student/update`,
    method: 'POST',
    data
  })
}

// 获取学生信息
export function getStudentInfo (params) {
  return request({
    url: `${parent}/api/math/student/info/student-id`,
    method: 'get',
    params
  })
}
